import { EnumeratedType } from '~/prix'
import { ExpressionType, Expression } from '~/prix/types/expression'

export default function prepareAssertions(expression: ExpressionType): Record<
  string,
  {
    expression: Expression
    label: string
  }
> {
  return Object.entries(expression.shape).reduce(
    (acc, [key, type]) => {
      if (!type.currentMeta.label) {
        return acc
      }

      // Boolean
      if (type.type === 'boolean') {
        const expression: Expression = {
          type: 'expression',
          kind: 'binary',
          left: {
            type: 'expression',
            kind: 'property',
            property: key,
          },
          operator: '=',
          right: {
            type: 'expression',
            kind: 'literal',
            literalType: 'boolean',
            value: true,
          },
        }
        acc[key] = {
          expression,
          label: type.currentMeta.label,
        }
      }

      // Enumerated
      if (type.type === 'string' && type.subType === 'enumerated') {
        for (const [enumKey, enumValue] of Object.entries((type as EnumeratedType).keysAndLabels)) {
          const fullKey = `${key}_${enumKey}`
          const expression: Expression = {
            type: 'expression',
            kind: 'binary',
            left: {
              type: 'expression',
              kind: 'property',
              property: key,
            },
            operator: '=',
            right: {
              type: 'expression',
              kind: 'literal',
              literalType: 'string',
              value: enumKey,
            },
          }
          acc[fullKey] = {
            expression,
            label: `${enumValue} (${type.currentMeta.label})`,
          }
        }
      }
      return acc
    },
    {} as Record<
      string,
      {
        expression: Expression
        label: string
      }
    >,
  )
}
